import { css } from 'styled-components';
import { StyledTheme } from '../../../../styles';

export const AuthenticationLoginBaseStyles = css<{ theme: StyledTheme }>`
  .authentication-region-link {
    cursor: pointer;
  }
`;
